import React from 'react';
import { Box, Card, CardActionArea, Typography, styled } from '@mui/material';
import { radius } from 'themes/radius';
import { ReactComponent as WeightIllustration } from 'assets/icons/WeightTrackerIllustration.svg';
import { ReactComponent as BloodPressureIllustration } from 'assets/icons/BloodPressureTrackerIllustration.svg';
import type { HealthTrackerBiometricType } from 'features/progress/healthTrackerTypes';

const ILLUSTRATIONS: Record<
  HealthTrackerBiometricType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  weight: WeightIllustration,
  blood_pressure: BloodPressureIllustration,
};

export interface HealthTrackerTypeTileProps {
  label: string;
  biometricType: HealthTrackerBiometricType;
  onClick: () => void;
}

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  // Figma tile proportions (184×166 at desktop).
  aspectRatio: '184 / 166',
  borderRadius: radius.card,
  backgroundColor: theme.palette.background.paper,
  boxShadow: `0 1px 4px 0 ${theme.palette.grey[400]}`,
}));

const ActionArea = styled(CardActionArea)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(3, 2),
  textAlign: 'center',
  '&:hover': { backgroundColor: theme.palette.background.paper },
}));

const IllustrationWrapper = styled(Box)({
  display: 'grid',
  placeItems: 'center',
});

export const HealthTrackerTypeTile: React.FC<HealthTrackerTypeTileProps> = ({
  label,
  biometricType,
  onClick,
}) => {
  const Illustration = ILLUSTRATIONS[biometricType];

  return (
    <StyledCard elevation={0} className="health-tracker-type-tile">
      <ActionArea onClick={onClick} disableRipple>
        <IllustrationWrapper aria-hidden="true">
          <Illustration focusable={false} />
        </IllustrationWrapper>
        <Typography variant="callout" color="grey.800">
          {label}
        </Typography>
      </ActionArea>
    </StyledCard>
  );
};
